<template>
  <div class="c-qa">
    <PageTitleVue titleText="Q&A" />
    <AnchorLinkList :items="generateAnchorLinkLists"></AnchorLinkList>
    <div class="c-qa__sections">
      <div
        class="c-qa__section"
        v-for="(section, i) in sections"
        :key="`qa-section-${i}`"
      >
        <div class="c-qa__title" :id="generateAnchorLinkLists[i].id">
          {{ section.title }}
        </div>
        <div class="c-qa__items">
          <div
            class="c-qa__item"
            v-for="(item, j) in section.items"
            :key="`qa-qas-${j}`"
          >
            <div class="c-qa__item__q">
              <div v-html="item.q" class="c-qa__item__a__contents"></div>
            </div>
            <div class="c-qa__item__a">
              <div v-html="item.a" class="c-qa__item__a__contents"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageTitleVue from "@/components/PageTitle.vue";
import AnchorLinkList from "@/components/AnchorLinkList.vue";

export default {
  name: "QandA",
  data: function() {
    return {
      sections: [
        {
          title: "本サイトについて",
          items: [
            {
              q: "Hoo-Loungeで何ができるか教えてください。",
              a:
                "ご入居までに必要な各種お申し込み、イベントの日程調整などをご用意しております。",
            },
            {
              q:
                "お知らせメールが届きません。もしくはお知らせメールを受け取らないようにしたい。",
              a:
                "ユーザー情報メニューの「メールアドレスを変更する」ボタンより、お知らせ通知を「受け取る」もしくは「受け取らない」にチェックし「変更」ボタンをクリックし設定してください。お知らせ通知を「受け取らない」にチェックしている場合は、「受け取る」にチェックし「変更」ボタンをクリックしてください。<br><br>また、迷惑メール対策等によりメールを送受信できない状態にある可能性があります。携帯電話会社のメールをご利用の場合は受信が制限されている場合がございます。「@mc-zoom.com」からお送りするメールを受信出来るよう受信設定を行ってください。",
            },
            {
              q: "ログインIDとパスワードをブラウザに保存したい。",
              a:
                "ログイン画面の「入力情報を保存」にチェックの上、ログインをお願いします。<br>但し、ログイン画面で「入力情報を保存」にチェックをした場合でも、ブラウザのセキュリティ設定によりパスワードが保存されない場合がございます。 その場合はお手数ですが、それぞれお使いのブラウザの設定を下記の通り変更をお願いします。<br><br>Android、Chromeの場合<br>「ホーム画面」→「Chrome」を開く→画面右上の「設定」を選択、「パスワード」画面で「パスワードの保存」をオンにします。<br><br>iPhoneの場合<br>ホーム画面の「設定」→「パスワードとアカウント」の「パスワードを自動入力」をオンにします。<br><br>※ご利用のブラウザ、OSのバージョンによっては多少異なる設定になっている場合もございますのでご留意ください。<br>※ご自身の端末以外（共用パソコンやネットカフェのような他人がアクセスできる端末）でご利用いただく場合は、ログイン時に「入力情報を保存」のチェックは行わないでください。",
            },
            {
              q: "ログアウトは必要ですか？",
              a:
                "ご自身の端末でご利用の場合は、特に必要ありません。<br><br>ご自身の端末以外（共用パソコンやネットカフェのような他人がアクセスできる端末）でログインした場合は、必ずメニューの「ログアウト」からログアウトしてください。",
            },
            {
              q: "複数アカウントを所有できますか？",
              a:
                "“1”住戸につき、“1”ID・パスワードとなります。（同居のご家族間でご使用される場合は、ID・パスワードを共有ください。）",
            },
          ],
        },
        {
          title: "引越等について",
          items: [
            {
              q: "お引越しはいつからできますか？",
              a:
                "鍵の引渡日以降であれば可能ですが、一斉引渡日の直後や土日祝日は希望が集中する可能性があります。",
            },
            {
              q: "引越幹事会社を利用して、お引越しをしなければなりませんか？",
              a:
                "引越幹事会社以外の引越会社をご利用いただいても問題ございません。ただし、お引っ越し日は必ず引越幹事会社宛にお申込みをお願いします。<br>また、お引っ越しの際のルールは、引越幹事会社が決定したものとなりますので、ご協力くださいますようお願いします。",
            },
            {
              q: "引渡日当日にお引っ越しをすることは可能ですか。",
              a:
                "引渡日当日のお引っ越しは可能です。ただしインテリアオプションをご発注いただいている場合、納品や施工が完了していない場合がございます。<br>インテリア会社へ完了日をご確認のうえ、お引っ越し日時の決定をお願いします。",
            },
            {
              q: "住民票の移動はいつからできますか？",
              a:
                "引渡日以降でお引っ越し日より２週間以内に自治体に転入届をご提出ください。",
            },
            {
              q: "購入した家具・家電の配送はお引っ越しと別日でも良いですか。",
              a:
                "家具・家電の搬入については搬入時間を確保して頂く必要はございません。ただし、お引っ越し等で通路やエレベーターが混み合うことが想定されますので、ご理解のほどお願いします。また事前に日時が分かる場合には引越会社へご相談をお願いします。",
            },
          ],
        },
        {
          title: "駐車場等について",
          items: [
            {
              q:
                "引渡日以降、施設に空きが出た場合にはどのように通知されますか？",
              a: "マンション内の掲示板にて広報いたしますので、ご確認ください。",
            },
            {
              q: "抽選くじ番号は、施設の区画番号ですか？",
              a:
                "抽選くじ番号は、施設の区画番号ではございません。あくまでも優先順位を決めるものとなり、お客様のご利用希望に沿って区画が決定いたしますので、抽選結果までお待ちください。",
            },
            {
              q: "入居後、車庫証明はどのように取得できますか？",
              a:
                "マンション管理事務室またはフージャースお客様相談室にて承っております。新たな車両購入の場合には購入予定の車両の諸元情報、車検証の住所や名義変更等の場合は現在保有されている車両の車検証をご用意のうえお申し付けください。",
            },
            {
              q: "抽選結果の通知前に利用可否ならびに区画を知りたい。",
              a:
                "抽選結果の通知前に結果をお知らせすることはできません。予めご了承ください。",
            },
            {
              q: "抽選結果が出た後に、区画を変更したい。",
              a:
                "抽選による区画決定後の区画変更はできかねますのでご了承ください。区画決定前であればご希望の変更を承りますので、お申し付けください。",
            },
            {
              q:
                "駐車場申込の時点で、車を購入予定で車検証がない場合どうしたらよいですか？",
              a:
                "購入される予定の車両がお決まりの場合は諸元情報をもとに収容可能な駐車場をご希望ください。車両が未定の場合でも駐車場を申込みいただけますが、車両購入時は収容可能サイズ・重量内の車両をお選びいただく形となります。",
            },
          ],
        },
        {
          title: "内覧会について",
          items: [
            {
              q: "内覧会の前や後にお部屋の中に立ち入ることは可能ですか？",
              a:
                "大変恐れ入りますが、内覧会開催日以外は建物への立ち入りは禁止とさせていただいております。ご了承ください。",
            },
            {
              q: "内覧会に車や自転車で行っても構わないでしょうか？",
              a:
                "ご契約いただいた物件によって、内覧会当日の駐車場・自転車置場の利用可否は異なります。内覧会前に送付するご案内資料をご確認ください。",
            },
            {
              q: "注文したインテリアオプションは内覧時には納品されていますか？",
              a:
                "原則、お引渡し日以降の設置となります。内覧時にご確認いただくことはできません。工事の日程につきましては、インテリア会社にご確認ください。※ゼネコンオプションは内覧会時にご確認が可能です。",
            },
            {
              q: "内覧会に参加することができません。どうしたらいいですか？",
              a:
                "代理の方（ご親族の方以外でも構いません）のご参加をご検討ください。ご参加が難しい場合には、お早めにご相談ください。",
            },
            {
              q: "家具家電会社を内覧会に呼んでも大丈夫ですか？",
              a:
                "お客様にご契約住戸を確認いただいた後であれば問題ございません。内覧開始時間より1時間～1時間半後を目安にお越しいただくよう、業者様とお打ち合わせをお願いいたします。",
            },
          ],
        },
        {
          title: "お支払い・お借り入れについて",
          items: [
            {
              q: "借入内容の変更をしたい場合はどうしたらいいですか?",
              a:
                "日程に余裕がなくなるため、 お客様にご協力いただくことが増えることになります。<br>ご協力いただける場合、引渡約定日(=融資実行日) に間に合うことを条件に対応可能か確認させていただきますので、<br>営業担当までご相談ください。",
            },
            {
              q: "諸費用の明細が知りたい",
              a:
                "管理関連費（修繕積立基金・管理準備金）、登記関連費（表題登記・権利登記・抵当権設定登記・固定資産税精算金）、<br>フージャース事務手数料、ローン事務手数料・保証料（売主があっせんする融資利用の場合のみ）等の合計金です。<br>※物件により異なる場合がございます。",
            },
            {
              q: "領収書を発行してもらえますか?",
              a:
                "売買契約書に記載の通り、お振込みでお支払いいただいた売買代金および諸費用につきましては、領収書は発行しておりません。<br>お振込み控えを領収書と代えさせていただきます。",
            },
            {
              q: "何回かに分けて異なる銀行から振込みしてもいいですか?",
              a: "問題ありません。",
            },
            {
              q: "残金の振込手数料は負担して頂けますか?",
              a: "振込手数料はお客様負担とさせていただいております。",
            },
            {
              q: "名義人以外から振込んでもいいですか?",
              a:
                "ご名義人の方からのお振込みをお願いします。<br> なお、 共有名義でご購入の場合でも 「お支払い明細の ご案内 (請求書) 」 は1枚での発行となります。<br>  持分等にご注意いただき、お振込みをお願いいたします。",
            },
            {
              q:
                " 請求書記載の手付金金額が、契約時に振込んだ額と違いますが、間違っていませんか?",
              a:
                "ご契約時には手付金と併せて売買契約書収入印紙代(1万円もしくは3万円)をお振込みいただいておりますので、ご入金金額と異なっております。",
            },
          ],
        },
        {
          title: "お引渡しについて",
          items: [
            {
              q:
                "共有名義で契約していますが、お引渡会への参加は名義人のいずれか1名のみでも大丈夫ですか?",
              a:
                "問題ございません。鍵のお受け取りが代理の方になる場合は、委任状等が必要になります。",
            },
            {
              q:
                "引っ越しが先になりますが、引っ越し前にお部屋に入っても大丈夫ですか?",
              a:
                "鍵のお引渡し以降は、自由に出入りしていただけます。<br>お引渡し直後はお引っ越しが集中するため、 エレベーターが混み合いますのでお待ちいただく可能性がございます。",
            },
            {
              q: "電気・ガス・水道は使えますか?",
              a:
                "水道、 電気は、事前に使用開始のご連絡 (お手続き)をお願いします (一括受電の場合は、引渡前に電気使用開始の申込書提出が必要となります)。<br>ガスについては、立ち合い開栓が必要になりますので、事前にガス会社にご予約をお願いします。",
            },
            {
              q: "引渡後に何かやることはありますか?",
              a:
                "自己居住用住宅ローンをご利用の方は、住民票の異動、住宅ローン控除対象の方は、初年度ローン控除の確定申告が必要です。<br>なお、ローン控除等の税制に関する内容、その他各種税制に関する内容は直接管轄の税務署へ問い合わせてください。<br>(翌年度以降はご勤務先の年末調整で住宅ローン控除を受けていただくことができます)",
            },
            {
              q:
                "売主を介さず、自分で住宅ローン手続きを行っています。当日何かやるべきことはありますか?",
              a:
                "引渡当日にお借入金額が売主口座に振り込まれるように事前にお手続きいただければ、引渡当日は引渡品一式をお受け取りいただくのみとなります。<br>お振込み手続きにつきましては、金融機関にご確認ください。<br>なお、弊社にて着金を確認した後にお引渡しをいたしますので、引渡会は午後からとなります。",
            },
          ],
        },
      ],
    };
  },
  components: {
    PageTitleVue,
    AnchorLinkList,
  },
  computed: {
    generateAnchorLinkLists() {
      const arr = this.sections.map((_, index) => {
        return { title: _.title, id: `archive${index}` };
      });
      return arr;
    },
  },
};
</script>

<style></style>
